import { ManageElement } from "./ManageElement";
import { HarvestLocationStore } from "stores/HarvestLocationStore";

export class HarvestLocation extends ManageElement {
  static _store: HarvestLocationStore;
}
